<template>
  <div id="tela-selfie">
    <div class="captura" :class="{'hidden':isError}">
      <div id="selfie"></div>
    </div>

    <div class="page-error margem-app">
      <Error
          v-if="isError"
          :title="error.title"
          :subtitle="error.subtitle"
          :button-text="error.btnTitle"
          v-bind:callback="this.reloadComponent"
      ></Error>
    </div>
  </div>
</template>

<script>

import Error from "../shared/Error";
import DispatchTags from "../../utils/DispatchTags";
import LoadScriptFilesService from "../../services/LoadScriptFilesService";
import AppService from "../../services/AppService";
import LivenessLogService from "../../services/LivenessLogService";

const ERROR = {
  title: "Não conseguimos tirar a foto do seu rosto",
  subtitle: "Não localizamos seu rosto para tirar a foto. Centralize ele na moldura e tente novamente",
  btnTitle: "Tentar novamente",
};

const ERROR_ACESSO_CAMERA = {
  title: "Algo deu errado ao acessar sua câmera",
  subtitle: "Precisamos do acesso pra tirar a foto e confirmar sua identidade",
  btnTitle: "Permitir acesso à câmera",
};
const SELFIE_FILE_CSS = "@/../static/selfie/livenessSerasa/livenessSerasa.css";
export default {
  name: "LivenessSerasa",
  components: {Error},
  data(){
    return {
      isError: false,
      error: {
        title: ERROR.title,
        subtitle: ERROR.subtitle,
        btnTitle: ERROR.btnTitle
      },
      intervalCallack:null,
      logLiveness: null,
      acessoCamera:false
    }
  },
  beforeRouteEnter(to, from, next) {
    let l = new LoadScriptFilesService();
    l.head_link(SELFIE_FILE_CSS)
        .then(() => next())
        .catch(() => alert("Falha ao carregar arquivo"));
  },
  beforeRouteLeave(to, from,next) {
    let l = new LoadScriptFilesService();
    l.del_link(SELFIE_FILE_CSS);
    this.pararDOMNodeInserted();
    this.stopStream();
    next();
  },
  created() {
    this.$store.dispatch("setTitulo", "Confirmar identidade");
    this.$store.dispatch("setLoadingStatus", true);
  },
  mounted() {
    this.logLivenessService = new LivenessLogService();
    let appService = new AppService();
    appService.carregarComponentSelefie();
    DispatchTags.dispatchScreenView("Selfie");
    var interval = setInterval(_ => {
      if (!this.$store.getters.componenteSelfieCarregado) {
        return;
      }
      this.selfie = window.selfie;
      this.iniciarSelfie();
      clearInterval(interval);
    }, 100);
  },
  methods:{
    iniciarSelfie:function (){
      this.iniciarDOMNodeInserted();
      let htmlElement = document.getElementById('selfie');
      this.selfie
          .iniciaSelfie(htmlElement)
          .then(res => {
            let sessionId = 'nlvnsrsexp';

            this.logLivenessService.sendLogLiveness(1,
                sessionId,
                null,
                null);

            this.$store.dispatch("setLoadingStatus", true);
            sessionStorage.setItem("s", res.selfie);
            this.nextPage();
          })
          .catch(e => {
            this.stopStream();
            let sessionId = 'nlvnsrsexp';
            this.logLivenessService.sendLogLiveness(2,sessionId,e.id,e.desc);
            DispatchTags.dispatchScreenView('SelfieError');
            DispatchTags.dispatchNoninteraction('SelfieError');
            if(e.id == 11){
              let i = ERROR_ACESSO_CAMERA;
              this.showError(i.title,i.subtitle,i.btnTitle);
              return;
            }
            this.showError(null,e.desc);
          });
    },
    reloadComponent() {
      let tag = (this.acessoCamera) ? 'ModalCamera' : 'SelfieError';
      DispatchTags.dispatchInraction(tag);
      this.acessoCamera = false;
      this.$store.dispatch("setLoadingStatus", true);
      //o componente só volta funcionar caso de reload na pagina =D
      this.$router.replace({name:'ConfirmarIdentidade'}).then(_ => {
        this.$store.dispatch("setLoadingStatus", true);
        window.location.reload(true);
      });
    },
    nextPage(){
      let doc_a = sessionStorage.getItem("A");
      let doc_b = sessionStorage.getItem("B");
      let tipo_captura = this.$store.getters.tipoCaptura;
      let name = (tipo_captura === 1 && (!doc_a || !doc_b)) ?  "DocSelecao" : "Analise";
      this.$router.push({ name: name });
    },
    showError(title,subtitle,btnTitle) {
      if (this.isError) {
        return;
      }
      let l = new LoadScriptFilesService();
      l.del_link(SELFIE_FILE_CSS);
      this.error.title = title ? title : ERROR.title;
      this.error.subtitle = subtitle ? subtitle : ERROR.subtitle;
      this.error.btnTitle = btnTitle ? btnTitle : ERROR.btnTitle;
      this.isError = true;
      this.$store.dispatch("setLoadingStatus", false);
    },
    videoIniciou() {
      var cameraVideo = document.getElementsByTagName('video');
      if (cameraVideo.length === 0) {
        return;
      }
      if(!window.selfieVideoStream){
        window.selfieVideoStream  =  window.selfie.camera.videoStream;
      }
      cameraVideo = cameraVideo[0];
      cameraVideo.autoplay = true;
      cameraVideo.addEventListener("click", () => cameraVideo.play(), false);
      $(cameraVideo).trigger("click");
      DispatchTags.dispatchNoninteraction("SelfieReady");
      window.selfieVideoStream = this.selfie.camera.videoStream;
      this.$store.dispatch("setLoadingStatus", false);
    },
    iniciarDOMNodeInserted() {
      //quando um elemento video é inserido no dom chama a função videoIniciou
      $(document).on('DOMNodeInserted', 'video', this.videoIniciou);
    },
    pararDOMNodeInserted() {
      //para de observar quando o elemento video é inserido no dom
      $(document).off('DOMNodeInserted', 'video', this.videoIniciou);
    },
    stopStream() {
      if(window.selfieVideoStream) {
        window.selfieVideoStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
    }
  }
}
</script>

<style scoped>
.hidden {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LivenessSerasa.vue